import * as $ from "jquery"

import {submitEwayPayment as submitEway} from "./paymentgateway"
import * as creditCard from "./credit-card"
import {CommandCaller} from "../lib/commands"

const submitAo = (div: JQuery, ajaxPageUrl: string) => {
	const params = {
		...creditCard.getCreditCardParams(),
		savePayment: (document.getElementById('savePayment') as HTMLInputElement).checked
	}

	div.block({message: "Please wait while your payment is set up..."})

	;(new CommandCaller(ajaxPageUrl).runPost(
		'submit payment',
		params) as Promise<string>)
	.then(
		(result : string) => location.assign(result),
		() => {
			div.unblock()
		}
	)
}


export const submit = (method: string): (div: JQuery, ajaxPageUrl: string) => void =>
	method === 'eway rapid' ? submitEway : submitAo

export const updateCreditCardType = (orderId: string, cardType: CreditCardTypeParams, ajaxPageUrl: string) => {
	;(new CommandCaller(ajaxPageUrl).runPost(
		'update credit card type',
		{orderId: orderId, cardType: cardType.code}) as Promise<{cvvDigits: number, invoice: string}>).then(
		function (response: {cvvDigits: number, invoice: string}) {
			const cvv = $("input[name='CreditCardNumberCVV']")
			cvv.prop('maxLength', response.cvvDigits)
			cvv.val(cvv.val().substr(0, response.cvvDigits))
			$("#reusablePayerInvoice").html(response.invoice)
		}
	)
}



// WEBPACK FOOTER //
// ./src/paymentgateway/reusable-payer.ts